import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./website/Home";
import { AppProvider } from "./website/context/Context";
import ProjectListPage from "./ProjectListPage";
import ProjectDetails from "./ProjectDetails";
import Gallery from "./Gallery";
import About from "./About";
import ContactUs from "./ContactUs";
import CsrGuidelines from "./website/guidlines-components/CsrGuidelines";
import RegistrationForm from "./website/common-components/RegistrationForm";
import MainLayout from "./website/layout/MainLayout";
import AuthLayout from "./website/layout/AuthLayout";
import { ProjectProvider } from "./website/context/ProjectContext";
import ShowInterest from "./website/project_listing/ShowInterest";
import ScrollToTop from "./website/layout/ScrollToTop";

function App() {
  return (
    <AppProvider>
      <ProjectProvider>
      <BrowserRouter>

        <Routes>
          <Route element={<MainLayout />} >
          
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<ProjectListPage />} />
          
          <Route path="/projects/:id" element={<ProjectDetails />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact_us" element={<ContactUs />} />
          <Route path="/guidelines" element={<CsrGuidelines />} />

          </Route>

 <Route element={<AuthLayout />}>
          <Route path="/registration" element={<RegistrationForm />} />
         <Route path="/show_intrest/:project_id" element={<ShowInterest />} />

        </Route>

        </Routes>

       
      </BrowserRouter>
       </ProjectProvider>
    </AppProvider>
  );
}

export default App;
